import Main from '@/base/main';

export default [
  {
    path: '/',
    redirect: '/index',
    name: 'Index',
    meta: {
      title: '',
    },
    component: Main,
    children: [
      {
        path: '/index',
        name: 'demo',
        meta: {
          title: '数据中心',
          // keepAlive: true,
        },
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dataView/ziYangDataViewBlack/ziYangDataCenter.vue'),
        // component: () => import(/* webpackChunkName: "dashboard" */ '@/views/demo/demo.vue'),
      },
    ],
  },
  {
    path: '/dataView/ziYangDataViewBlack',
    name: 'ziYangDataViewBlack',
    meta: {
      title: '资阳大屏',
    },
    component: () => import(/* webpackChunkName: "ziYangDataViewBlack" */ '@/views/dataView/ziYangDataViewBlack/ziYangDataViewNew.vue'),
  }, // 资阳大屏 (深色)
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: '登录',
    },
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/login.vue'),
  }, // 登录
  {
    path: '/organization',
    redirect: '/organization/user',
    name: 'Organization',
    meta: {
      title: '组织管理',
    },
    component: Main,
    children: [
      {
        path: '/organization/user',
        name: 'User',
        meta: {
          title: '用户管理',
        },
        component: () => import(/* webpackChunkName: "user" */ '@/views/system/organization/user/user.vue'),
      },
      {
        path: '/organization/institution',
        name: 'Institution',
        meta: {
          title: '机构管理',
        },
        component: () => import(/* webpackChunkName: "institution" */ '@/views/system/organization/institution/institution.vue'),
      },
      {
        path: '/organization/company',
        name: 'Company',
        meta: {
          title: '公司管理',
        },
        component: () => import(/* webpackChunkName: "company" */ '@/views/system/organization/company/company.vue'),
      },
      {
        path: '/organization/profession',
        name: 'Profession',
        meta: {
          title: '岗位管理',
        },
        component: () => import(/* webpackChunkName: "profession" */ '@/views/system/organization/profession/profession.vue'),
      },
      {
        path: '/organization/region',
        name: 'Region',
        meta: {
          title: '区域管理',
        },
        component: () => import(/* webpackChunkName: "region" */ '@/views/system/organization/region/region.vue'),
      },
    ],
  }, // 组织管理
  {
    path: '/permission',
    redirect: '/permission/role',
    name: 'Permission',
    meta: {
      title: '权限管理',
    },
    component: Main,
    children: [
      {
        path: '/permission/role',
        name: 'Role',
        meta: {
          title: '角色管理',
        },
        component: () => import(/* webpackChunkName: "role" */ '@/views/system/permission/role/role.vue'),
      },
    ],
  }, // 权限管理
  {
    path: '/settings',
    redirect: '/settings/menu',
    name: 'Settings',
    meta: {
      title: '系统设置',
    },
    component: Main,
    children: [
      {
        path: '/settings/menu',
        name: 'Menu',
        meta: {
          title: '菜单管理',
        },
        component: () => import(/* webpackChunkName: "menu" */ '@/views/system/settings/menu/menu.vue'),
      },
      {
        path: '/settings/dict',
        name: 'Dict',
        meta: {
          title: '字典管理',
        },
        component: () => import(/* webpackChunkName: "dict" */ '@/views/system/settings/dict/dict.vue'),
      },
      {
        path: '/settings/userManagement',
        name: 'UserManagement',
        meta: {
          title: '用户管理',
        },
        component: () => import(/* webpackChunkName: "userManagement" */ '@/views/system/settings/userManagement/userManagement.vue'),
      },
    ],
  }, // 系统设置

  {
    path: '/workflow',
    redirect: '/workflow/processManagement',
    name: 'Workflow',
    meta: {
      title: '工作流程',
    },
    component: Main,
    children: [
      {
        path: '/workflow/processManagement',
        name: 'ProcessManagement',
        meta: {
          title: '流程管理',
        },
        component: () => import(/* webpackChunkName: "processManagement" */ '@/views/professionalWork/workflow/processManagement/processManagement.vue'),
      },
      {
        path: '/workflow/basicSettings',
        name: 'BasicSettings',
        meta: {
          title: '基础设置',
        },
        component: () => import(/* webpackChunkName: "basicSettings" */ '@/views/professionalWork/workflow/basicSettings/basicSettings.vue'),
      },
      {
        path: '/workflow/formDesign',
        name: 'FormDesign',
        meta: {
          title: '表单设计',
        },
        component: () => import(/* webpackChunkName: "formDesign" */ '@/views/professionalWork/workflow/formDesign/formDesign.vue'),
      },
      {
        path: '/workflow/processDesign',
        name: 'ProcessDesign',
        meta: {
          title: '流程设计',
        },
        component: () => import(/* webpackChunkName: "processDesign" */ '@/views/professionalWork/workflow/processDesign/processDesign.vue'),
      },
      {
        path: '/workflow/advancedSetting',
        name: 'AdvancedSetting',
        meta: {
          title: '高级设置',
        },
        component: () => import(/* webpackChunkName: "advancedSetting" */ '@/views/professionalWork/workflow/advancedSetting/advancedSetting.vue'),
      },
    ],
  }, // 工作流程

  {
    path: '/patrolManagement',
    redirect: '/patrolManagement/patrolLine',
    name: 'PatrolManagement',
    meta: {
      title: '巡检管理',
    },
    component: Main,
    children: [
      {
        path: '/patrolManagement/patrolLine',
        name: 'PatrolLine',
        meta: {
          title: '巡检线路',
        },
        component: () => import(/* webpackChunkName: "patrolLine" */ '@/views/patrolManagement/patrolLine/patrolLine.vue'),
      },
      {
        path: '/patrolManagement/patrolPoint',
        name: 'PatrolPoint',
        meta: {
          title: '巡检点',
        },
        component: () => import(/* webpackChunkName: "patrolPoint" */ '@/views/patrolManagement/patrolPoint/patrolPoint.vue'),
      },
      {
        path: '/patrolManagement/patrolEquip',
        name: 'PatrolEquip',
        meta: {
          title: '巡检设备',
        },
        component: () => import(/* webpackChunkName: "patrolEquip" */ '@/views/patrolManagement/patrolEquip/patrolEquip.vue'),
      },
      {
        path: '/patrolManagement/patrolVerify',
        name: 'PatrolVerify',
        meta: {
          title: '审核管理',
        },
        component: () => import(/* webpackChunkName: "patrolVerify" */ '@/views/patrolManagement/patrolVerify/patrolVerify.vue'),
      },
      {
        path: '/patrolManagement/patrolTask',
        name: 'PatrolTask',
        meta: {
          title: '巡检任务',
        },
        component: () => import(/* webpackChunkName: "patrolTask" */ '@/views/patrolManagement/patrolTask/patrolTask.vue'),
      },
      {
        path: '/patrolManagement/devicePatrolTask',
        name: 'DevicePatrolTask',
        meta: {
          title: '设备巡检',
        },
        component: () => import(/* webpackChunkName: "patrolTask" */ '@/views/patrolManagement/devicePatrolTask/devicePatrolTask.vue'),
      },
      {
        path: '/patrolManagement/patrolReceive',
        name: 'PatrolReceive',
        meta: {
          title: '巡检任务配置',
        },
        component: () => import(/* webpackChunkName: "patrolReceive" */ '@/views/patrolManagement/patrolReceive/patrolReceive.vue'),
      },
      {
        path: '/patrolManagement/patrolPlan',
        name: 'PatrolPlan',
        meta: {
          title: '巡检方案',
        },
        component: () => import(/* webpackChunkName: "patrolPlan" */ '@/views/patrolManagement/patrolPlan/patrolPlan.vue'),
      },
      {
        path: '/schedule/plan',
        name: 'SchedulePlan',
        meta: {
          title: '排班方案',
        },
        component: () => import(/* webpackChunkName: "plan" */ '@/views/professionalWork/schedule/plan/plan.vue'),
      },
    ],
  }, // 巡检管理

  {
    path: 'integralManagementMenu',
    redirect: '/integralManagementMenu/integral',
    name: 'IntegralManagement',
    meta: {
      title: '积分管理',
    },
    component: Main,
    children: [
      {
        path: '/integralManagementMenu/integral',
        name: 'Integral',
        meta: {
          title: '积分管理',
        },
        component: () => import(/* webpackChunkName: "integralManagement" */ '@/views/integralManagement/integralManagement.vue'),
      },
      {
        path: '/integralAllocation/integralAllocation',
        name: 'IntegralAllocation',
        meta: {
          title: '积分配置',
        },
        component: () => import(/* webpackChunkName: "integralAllocation" */ '@/views/integralAllocation/integralAllocation.vue'),
      },
    ],
  }, // 积分管理
  {
    path: '/responsibility',
    redirect: '/responsibility/performanceManagement',
    name: 'Responsibility',
    meta: {
      title: '责任履职',
    },
    component: Main,
    children: [
      {
        path: '/responsibility/performanceManagement',
        name: 'PerformanceManagement',
        meta: {
          title: '履职管理',
        },
        component: () => import(/* webpackChunkName: "performanceManagement" */ '@/views/responsibility/performanceManagement.vue'),
      },
      {
        path: '/inventoryManagement/inventoryManagement',
        name: 'InventoryManagement',
        meta: {
          title: '履职清单管理',
        },
        component: () => import(/* webpackChunkName: "performanceManagement" */ '@/views/inventoryManagement/inventoryManagement.vue'),
      },
      {
        path: '/enterprisePerformanceList/enterprisePerformanceList',
        name: 'EnterprisePerformanceList',
        meta: {
          title: '企业履职清单',
        },
        component: () => import(/* webpackChunkName: "EnterprisePerformanceList" */ '@/views/enterprisePerformanceList/enterprisePerformanceList.vue'),
      },
      {
        path: '/inventoryManagement/dutyListTemplate',
        name: 'DutyListTemplate',
        meta: {
          title: '履职清单模板',
        },
        component: () => import(/* webpackChunkName: "performanceManagement" */ '@/views/inventoryManagement/dutyListTemplate.vue'),
      },
      {
        path: '/inventoryManagement/dutyListBatch',
        name: 'DutyListBatch',
        meta: {
          title: '履职清单批量',
        },
        component: () => import(/* webpackChunkName: "performanceManagement" */ '@/views/inventoryManagement/dutyListBatch.vue'),
      },
    ],
  }, // 责任履职

  {
    path: '/doublePrevention',
    redirect: '/doublePrevention/riskControlList',
    name: 'DoublePrevention',
    meta: {
      title: '双重预防',
    },
    component: Main,
    children: [
      {
        path: '/doublePrevention/hazardDepartConfig',
        name: 'HazardDepartConfig',
        meta: {
          title: '隐患部门配置',
        },
        component: () => import(/* webpackChunkName: "RiskControlList" */ '@/views/doublePrevention/hazardDepartConfig/hazardDepartConfig.vue'),
      },
      {
        path: '/doublePrevention/riskControlList',
        name: 'RiskControlList',
        meta: {
          title: '风险分级管控清单',
        },
        component: () => import(/* webpackChunkName: "RiskControlList" */ '@/views/doublePrevention/riskControlList/riskControlList.vue'),
      },
      {
        path: '/doublePrevention/riskControlListApproval',
        name: 'RiskControlListApproval',
        meta: {
          title: '企业风险信息变更审批',
        },
        component: () => import(/* webpackChunkName: "RiskControlListApproval" */ '@/views/doublePrevention/riskControlList/approvalList/approvalList.vue'),
      },
      {
        path: '/doublePrevention/hazardChecklist',
        name: 'HazardChecklist',
        meta: {
          title: '隐患排查清单',
        },
        component: () => import(/* webpackChunkName: "HazardChecklist" */ '@/views/doublePrevention/hazardChecklist/hazardChecklist.vue'),
      },
      {
        path: '/doublePrevention/hazardManagement',
        name: 'HazardManagement',
        meta: {
          title: '隐患管理',
        },
        component: () => import(/* webpackChunkName: "HazardManagement" */ '@/views/doublePrevention/hazardManagement/hazardManagement.vue'),
      },
      {
        path: '/riskPointHazardSource/riskPointHazardSource',
        name: 'RiskPointHazardSource',
        meta: {
          title: '风险点危险源',
        },
        component: () => import(/* webpackChunkName: "riskPointHazardSource" */ '@/views/doublePrevention/riskPointHazardSource/riskPointHazardSource.vue'),
      },
      {
        path: '/dynamicRisk/riskFollowUp',
        name: 'RiskFollowUp',
        meta: {
          title: '风险随查',
        },
        component: () => import(/* webpackChunkName: "environmentalRiskControlList" */ '@/views/doublePrevention/riskFollowUp/riskFollowUp.vue'),
      },
    ],
  }, // 双重预防

  {
    path: '/siteManagement',
    redirect: '/siteManagement/siteManagement',
    name: 'SiteManagement',
    meta: {
      title: '现场管理',
    },
    component: Main,
    children: [
      {
        path: '/siteManagement/siteManagement',
        name: 'SiteManagement',
        meta: {
          title: '作业票',
        },
        component: () => import(/* webpackChunkName: "siteManagement" */ '@/views/siteManagement/siteManagement.vue'),
      },
      {
        path: '/workingBillManagement/workingBillManagement',
        name: 'WorkingBillManagement',
        meta: {
          title: '作业票配置',
        },
        component: () => import(/* webpackChunkName: "WorkingBillManagement" */ '@/views/yunnan-work/workingBill/workingBillManagement/workingBillManagement.vue'),
      },
      {
        path: '/device-info/index',
        name: 'DeviceInfo',
        meta: {
          title: '主要设备信息',
        },
        component: () => import(/* webpackChunkName: "deviceInfo" */ '@/views/deviceInfo/device-info.vue'),
      },
      {
        path: '/risk/temporaryHomeworkReporting',
        name: 'TemporaryHomeworkReporting',
        meta: {
          title: '临时作业报备',
        },
        component: () => import(/* webpackChunkName: "temporaryHomeworkReporting" */ '@/views/risk/temporaryHomeworkReporting/temporaryHomeworkReporting.vue'),
      },
      {
        path: '/videoManagement/videoBind',
        name: 'VideoManagement',
        meta: {
          title: '视频数据绑定',
        },
        component: () => import(/* webpackChunkName: "videoManagement" */ '@/views/videoManagement/videoBind/videoList.vue'),
      },
      {
        path: '/oneClickAlarm/oneClickAlarmInfo',
        name: 'OneClickAlarmInfo',
        meta: {
          title: '一键报警',
        },
        component: () => import(/* webpackChunkName: "OneClickAlarmInfo" */ '@/views/oneClickAlarm/alarm-list.vue'),
      },
    ],
  }, // 现场管理-作业票
  {
    path: '/inspectionContents',
    redirect: '/inspectionContents/inspectionContents',
    name: 'InspectionContents',
    meta: {
      title: '安环检查',
    },
    component: Main,
    children: [
      {
        path: '/inspectionContents/inspectionContents',
        name: 'InspectionContents',
        meta: {
          title: '考核标准',
        },
        component: () => import(/* webpackChunkName: "inspectionContents" */ '@/views/inspectionContents/inspectionContents.vue'),
      },
      {
        path: '/inspectionContents/safetyAndEnvironmentAssessment',
        name: 'SafetyAndEnvironmentAssessment',
        meta: {
          title: '安环考核',
        },
        component: () => import(/* webpackChunkName: "safetyAndEnvironmentAssessment" */ '@/views/inspectionContents/safetyAndEnvironmentAssessment/safetyAndEnvironmentAssessment.vue'),
      },
      {
        path: '/inspectionContents/checklist',
        name: 'Checklist',
        meta: {
          title: '安全检查',
        },
        component: () => import(/* webpackChunkName: "checklist" */ '@/views/inspectionContents/checklist/checklist.vue'),
      },
      {
        path: '/inspectionContents/aCheckTemplate',
        name: 'ACheckTemplate',
        meta: {
          title: '检查标准',
        },
        component: () => import(/* webpackChunkName: "aCheckTemplate" */ '@/views/inspectionContents/aCheckTemplate/aCheckTemplate.vue'),
      },
      {
        path: '/inspectionContents/rectificationNotice',
        name: 'RectificationNotice',
        meta: {
          title: '整改通知单',
        },
        component: () => import(/* webpackChunkName: "RectificationNotice" */ '@/views/inspectionContents/rectificationNotice/rectificationNotice.vue'),
      },
    ],
  }, // 监督检查
  {
    path: '/comprehensiveReports',
    redirect: '/inspectionContents/inspectionContents',
    name: 'ComprehensiveReports',
    meta: {
      title: '综合报表',
    },
    component: Main,
    children: [
      {
        path: '/inspectionContents/checkReport',
        name: 'CheckReport',
        meta: {
          title: '检查报表',
        },
        component: () => import(/* webpackChunkName: "CheckReport" */ '@/views/inspectionContents/checklist/checkReport.vue'),
      },
      {
        path: '/patrolManagement/patrolReport',
        name: 'PatrolReport',
        meta: {
          title: '巡检报表',
        },
        component: () => import(/* webpackChunkName: "patrolReport" */ '@/views/patrolManagement/patrolReport/patrolReport.vue'),
      },
      {
        path: '/enterprisePerformanceList/enterprisePerformanceReport',
        name: 'EnterprisePerformanceReport',
        meta: {
          title: '履职报表',
        },
        component: () => import(/* webpackChunkName: "EnterprisePerformanceReport" */ '@/views/enterprisePerformanceList/enterprisePerformanceReport.vue'),
      },
    ],
  }, // 综合报表
  {
    path: '/emergencyDrills',
    redirect: '/emergencyDrills/record',
    name: 'EmergencyDrills',
    meta: {
      title: '应急演练记录',
    },
    component: Main,
    children: [
      {
        path: '/emergencyDrills/record',
        name: 'EmergencyDrills',
        meta: {
          title: '应急演练记录',
        },
        component: () => import(/* webpackChunkName: "emergencyDrills" */ '@/views/emergencyDrills/record/record.vue'),
      },
      {
        path: '/emergencyDrills/plan',
        name: 'EmergencyDrills',
        meta: {
          title: '应急演练计划',
        },
        component: () => import(/* webpackChunkName: "emergencyDrills" */ '@/views/emergencyDrills/plan/plan.vue'),
      },
      {
        path: '/planManagementPreplan/planManagementPreplan',
        name: 'PlanManagementPreplan',
        meta: {
          title: '预案管理',
        },
        component: () => import(/* webpackChunkName: "planManagementPreplan" */ '@/views/planManagementPreplan/planManagementPreplan.vue'),
      },
      {
        path: '/materialsandEquipmentEquipment/materialsandEquipmentEquipment',
        name: 'MaterialsandEquipmentEquipment',
        meta: {
          title: '物资装备',
        },
        component: () => import(/* webpackChunkName: "materialsandEquipmentEquipment" */ '@/views/materialsandEquipmentEquipment/materialsandEquipmentEquipment.vue'),
      },
      {
        path: '/teamManagementTeam/teamManagementTeam',
        name: 'TeamManagementTeam',
        meta: {
          title: '队伍管理',
        },
        component: () => import(/* webpackChunkName: "teamManagementTeam" */ '@/views/teamManagementTeam/teamManagementTeam.vue'),
      },
      {
        path: '/enterpriseEmergencyPlan/enterpriseEmergencyPlan',
        name: 'EnterpriseEmergencyPlan',
        meta: {
          title: '企业预案管理',
        },
        component: () => import(/* webpackChunkName: "teamManagementTeam" */ '@/views/enterpriseEmergencyPlan/enterpriseEmergencyPlan.vue'),
      },
    ],
  }, // 应急演练
  {
    path: '/mineMonitoringManagement',
    redirect: '/mineMonitoringManagement/safetyMonitoring',
    name: 'MineMonitoringManagement',
    meta: {
      title: '矿山监测',
    },
    component: Main,
    children: [
      {
        path: '/mineMonitoringManagement/safetyMonitoring',
        name: 'SafetyMonitoring',
        meta: {
          title: '安全监测',
        },
        component: () => import(/* webpackChunkName: "safetyMonitoring" */ '@/views/mineMonitoringManagement/safetyMonitoring.vue'),
      },
      {
        path: '/mineMonitoringManagement/deviceManagement',
        name: 'DeviceManagement',
        meta: {
          title: '设备管理',
        },
        component: () => import(/* webpackChunkName: "deviceManagement" */ '@/views/mineMonitoringManagement/deviceManagement/deviceManagement.vue'),
      },
    ],
  }, // 矿山监测
  {
    path: '/trainManage',
    redirect: '/trainManage/trainRequest',
    name: 'TrainManage',
    meta: {
      title: '培训管理',
    },
    component: Main,
    children: [
      {
        path: '/trainManage/trainRequest',
        name: 'TrainRequest',
        meta: {
          title: '培训申请',
        },
        component: () => import(/* webpackChunkName: "trainRequest" */ '@/views/trainManagement/trainRequest/trainRequest.vue'),
      },
      {
        path: '/trainManage/trainRecord',
        name: 'TrainRecord',
        meta: {
          title: '培训记录',
        },
        component: () => import(/* webpackChunkName: "trainRecord" */ '@/views/trainManagement/trainRecord/trainRecord.vue'),
      },
    ],
  }, // 培训管理
  {
    path: '/enterpriseSubjectInformation',
    redirect: '/enterpriseSubjectInformation/businessManagement',
    name: 'EnterpriseSubjectInformationtList',
    meta: {
      title: '企业信息管理',
    },
    component: Main,
    children: [
      {
        path: '/enterpriseSubjectInformation/businessManagement',
        name: 'BusinessManagement',
        meta: {
          title: '企业信息管理',
        },
        component: () => import(/* webpackChunkName: "BusinessManagement" */ '@/views/enterpriseSubjectInformation/businessManagement/businessManagementList.vue'),
      },
    ],
  }, // 企业信息管理
  {
    path: '/messageNotificationsManagement',
    redirect: '/messageNotifications/messageNotificationsManagement',
    name: 'MessageNotificationsManagement',
    meta: {
      title: '消息通知',
    },
    component: Main,
    children: [
      {
        path: '/info/info',
        name: 'MessageNotifications',
        meta: {
          title: '消息通知',
        },
        component: () => import(/* webpackChunkName: "MessageNotifications" */ '@/views/messageNotifications/messageNotifications.vue'),
      },
    ],
  }, // 消息通知
];
